import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { LogService } from 'src/app/core/services/log/log.service';
import { FacadeService } from 'src/app/core/services/facade.service';
import { AideType, AideTypeStringEnum, RestitutionPrestation, RestitutionTypeEnum, StatutProlongationEnum } from 'src/app/shared/models/restitutionPrestation';
import {
	AbstractControl,
	FormGroup,
	ValidationErrors,
	ValidatorFn
} from '@angular/forms';
import { Address } from 'src/app/shared/models/address';
import { Observable, of, Subscriber } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { TypeaheadMatch } from 'ngx-bootstrap/typeahead';
import { PARAM_LABEL_INTERVENANT } from 'src/app/core/services/constant/constants.service';
import { User } from 'src/app/shared/models/security/user';
import { NominatimResponse } from 'src/app/shared/models/api-response/nominatim-response';
import { Employee } from 'src/app/shared/models/employee/employee';
import { ModaliteReunion } from 'src/app/shared/models/modaliteReunion';
import { TypeEntretien } from 'src/app/shared/models/typeEntretien';
import { Prestation, PrestationStatut, PrestationType } from 'src/app/shared/models/prestation';
import { Tache } from 'src/app/shared/models/tache';
import { Options } from '@angular-slider/ngx-slider';
import { Router } from '@angular/router';
import { Editor } from 'ngx-editor';

@Component({
	selector: 'app-restitutionPrestation-form',
	templateUrl: './restitutionPrestation-form.component.html',
	styleUrls: ['./restitutionPrestation-form.component.scss']
})
export class RestitutionPrestationFormComponent implements OnInit {
	@Input() restitutionPrestation: RestitutionPrestation;
	@Input() prestation: Prestation;
	@Input() isAddForm: boolean;
	@Input() isAddressSelected: { value: boolean };
	@Input() isAddressDefault: { value: boolean };
	@Input() isAddressStructureSelected: { value: boolean };
	@Input() isAddressStructureDefault: { value: boolean };
	//Boolean empêchant l'utilisateur d'envoyer plusieurs fois le formulaire
	@Input() isValidateButtonClicked: { value: boolean };
	@Input() form: FormGroup;
	@Output() sendForm: EventEmitter<any> = new EventEmitter();
	@Output() hideModal: EventEmitter<any> = new EventEmitter();


	MAX_NAME_CHAR = 25;
	NAME_PATTERN = new RegExp("^[a-zA-z'éèàç.-_]+( [a-zA-z'éèàç.-_]+)*$");

	restitutionPrestations: RestitutionPrestation[] = null;

	labelIntervenantCapitalized: string;

	selectedaddress?: Address;
	selectedaddressStructure?: Address;
	typeaheadLoading?: boolean;
	addressList: Observable<NominatimResponse[]>;
	addressStructureList: Observable<NominatimResponse[]>;
	searchResults: NominatimResponse[];

	listModaliteReunion: ModaliteReunion[];
	listTache: Tache[];
	listTypeEntretien: TypeEntretien[];
	listIntervenant: Employee[];
	listRestitution: RestitutionPrestation[];
	public RestitutionTypeEnum = RestitutionTypeEnum;
	public AideStringEnum = AideTypeStringEnum;
	public StatutProlongationEnum = StatutProlongationEnum;

	isPreferencesActive = false;
	totalHeuresRestitutions = 0;

	listAideEnum = AideType;
	listAllAide = Object.keys(this.listAideEnum);
	listSelectedAide: string[] = [];

	isIntervenant: boolean;
	user: User;
	maxDate: Date;
	minDate: Date;

	editorOrganismePecBenef: Editor;
	editorPointVigilance: Editor;
	editorConsequencesHandicap: Editor;
	editorAidesTechniques: Editor;
	editorAidesHumaines: Editor;
	editorAidesOrganisationnelles: Editor;
	editorMediation: Editor;
	editorDemarcheAdministrativeDetails: Editor;

	nbConsumedHours: number;

	constructor(
		private logger: LogService, 
		private facade: FacadeService, 
		private router: Router) {
	}

	ngOnInit(): void {
		this.editorOrganismePecBenef = new Editor();
		this.editorPointVigilance = new Editor();
		this.editorConsequencesHandicap = new Editor();
		this.editorAidesTechniques = new Editor();
		this.editorAidesHumaines = new Editor();
		this.editorAidesOrganisationnelles = new Editor();
		this.editorMediation = new Editor();
		this.editorDemarcheAdministrativeDetails = new Editor();
		if (this.restitutionPrestation) {
			this.isIntervenant = this.facade.dataStorageService.isIntervenant();
			this.labelIntervenantCapitalized =
				this.facade.dataStorageService.getLabelCapitalized(
					PARAM_LABEL_INTERVENANT
				);
			this.user = this.facade.dataStorageService.getUser();

			this.isPreferencesActive =
				this.facade.dataStorageService.isPreferencesBeneficiaireActive();

			const prestationId = +this.router.url.split('/').pop();
			this.facade.prestationService
			.getPrestationById(prestationId)
			.subscribe((prestation: Prestation) => {
				this.prestation = prestation;
			});

			this.facade.restitutionPrestationService.getByPrestation(this.prestation?.id).subscribe({
				next: (val) => {
					this.listRestitution = val;
				},
				error: (err) => {
					this.logger.error(err);
				}
			});

			// Deep copy
			//this.listSelectedIntervenant = [...this.restitutionPrestation.intervenants];
			this.nbConsumedHours = this.calculateConsumedHours(this.prestation.id);
			console.log(this.restitutionPrestation);

			if (this.isAddForm) {
				this.form.patchValue({
					dateDemarrage:
					this.prestation.dateDebut !== null && this.prestation.dateDebut !== ''
								? new Date(this.prestation.dateDebut)
								: null,
					dateValidQualif:
								this.prestation.dateDebut !== null && this.prestation.dateDebut !== ''
											? new Date(this.prestation.dateDebut)
											: null,
					dateButoirDepot:
								this.prestation.dateLimite !== null && this.prestation.dateLimite !== ''
											? new Date(this.prestation.dateLimite)
											: null,
					heuresPrev: this.prestation.dureePrevisionnelle,
					totalHeures: this.nbConsumedHours,
					totalHeuresRestantes: this.prestation.dureePrevisionnelle - this.nbConsumedHours,
					mobilisationAutreAs: this.prestation.serviceChefFile != null ? true : false
				})
			}

			if (!this.isAddForm) {
				this.listSelectedAide = this.restitutionPrestation.reponsesIdentifiees != null ? [...this.restitutionPrestation.reponsesIdentifiees] : [];
				this.form.patchValue({
					dateValidQualif:
						this.restitutionPrestation.dateValidQualif !== null && this.restitutionPrestation.dateValidQualif !== ''
							? new Date(this.restitutionPrestation.dateValidQualif)
							: null,
					dateButoirDepot:
						this.restitutionPrestation.dateButoirDepot !== null && this.restitutionPrestation.dateButoirDepot !== ''
							? new Date(this.restitutionPrestation.dateButoirDepot)
							: null,
					dateDepotRestFinale:
						this.restitutionPrestation.dateDepotRestFinale !== null && this.restitutionPrestation.dateDepotRestFinale !== ''
							? new Date(this.restitutionPrestation.dateDepotRestFinale)
							: null,
							type: this.restitutionPrestation.type,
							prolongation: this.restitutionPrestation.prolongation,
							dateDemarrage:
						this.restitutionPrestation.dateDemarrage !== null && this.restitutionPrestation.dateDemarrage !== ''
							? new Date(this.restitutionPrestation.dateDemarrage)
							: null,
							date1erRv:
							this.restitutionPrestation.date1erRv !== null && this.restitutionPrestation.date1erRv !== ''
								? new Date(this.restitutionPrestation.date1erRv)
								: null,
								dateFinPrev:
							this.restitutionPrestation.dateFinPrev !== null && this.restitutionPrestation.dateFinPrev !== ''
								? new Date(this.restitutionPrestation.dateFinPrev)
								: null,
								heuresPrev: this.restitutionPrestation.heuresPrev,
								totalHeures: this.restitutionPrestation.totalHeures,
								heuresBilaterales: this.restitutionPrestation.heuresBilaterales,
								heuresCollectif: this.restitutionPrestation.heuresCollectif,
								heuresEmployeur: this.restitutionPrestation.heuresEmployeur,
								totalHeuresRestantes: this.restitutionPrestation.totalHeuresRestantes,
								mobilisationAutreAs: this.restitutionPrestation.mobilisationAutreAs,
								raisonSocialeAutre: this.restitutionPrestation.raisonSocialeAutre,
								pointVigilance: this.restitutionPrestation.pointVigilance,
								organismePecBenef: this.restitutionPrestation.organismePecBenef,
								consequencesHandicap: this.restitutionPrestation.consequencesHandicap,
								reponsesIdentifiees: this.restitutionPrestation.reponsesIdentifiees,
								aidesTechniques: this.restitutionPrestation.aidesTechniques,
								aidesHumaines: this.restitutionPrestation.aidesHumaines,
								aidesOrganisationnelles: this.restitutionPrestation.aidesOrganisationnelles,
								mediation: this.restitutionPrestation.mediation,
								statutDemandeProlongation: this.restitutionPrestation.statutDemandeProlongation,
								demarcheAdministrative: this.restitutionPrestation.demarcheAdministrative,
								demarcheAdministrativeDetails: this.restitutionPrestation.demarcheAdministrativeDetails
				});
				console.log(this.restitutionPrestation.reponsesIdentifiees);
			} 

			if(this.isIntervenant){
				this.maxDate = new Date();
				var date = new Date();
				if(Number(new Date().toISOString().slice(0, 2)) < 22){
					this.minDate = new Date(date.getFullYear(), date.getMonth()-1, 22);
				}else{
					this.minDate = new Date(date.getFullYear(), date.getMonth() + 1, 0);
				}
			}

		}
	}

	isAideCheck(spec: string): boolean {
		return this.listSelectedAide?.some(
			(specItfc) => specItfc === spec
		);
	}

	updateSelectedAide(e: any, spe: string) {
		if (e.target.checked) {
		   if (!this.listSelectedAide.some((z) => z === spe)) {
			   this.listSelectedAide.push(spe);
		   }
	   } else {
		   if (this.listSelectedAide.some((z) => z === spe)) {
			   this.listSelectedAide = this.listSelectedAide.filter(
				   (z) => z !== spe
			   );
		   }
	   }
   }

   	calculateConsumedHours(selectedPrestation : number){
		let listActivite;
		let totalHeuresActivites = 0;
		this.facade.activitePrestationService.getByPrestation(selectedPrestation).subscribe({
			next: (val) => {
				listActivite = val;
			},
			error: (err) => {
				this.logger.error(err);
			}
		});

		listActivite?.forEach((activite) => {
			totalHeuresActivites += activite.chargeTravail;
		})
	return totalHeuresActivites
}

	// ngOnChanges(): void {
	// 	// this.mapUnavailabilities();
	// }

	submitForm() {
		console.log(this.restitutionPrestation);
		if (this.form.valid){

			this.isValidateButtonClicked.value = true;
			this.restitutionPrestation.dateValidQualif = this.form.get('dateValidQualif').value;
			this.restitutionPrestation.dateButoirDepot = this.form.get('dateButoirDepot').value;
			this.restitutionPrestation.dateDepotRestFinale = this.form.get('dateDepotRestFinale').value;
			this.restitutionPrestation.type = this.form.get('type').value;
			this.restitutionPrestation.prolongation = this.form.get('prolongation').value;
			this.restitutionPrestation.dateDemarrage = this.form.get('dateDemarrage').value;
			this.restitutionPrestation.date1erRv = this.form.get('date1erRv').value;
			this.restitutionPrestation.dateFinPrev = this.form.get('dateFinPrev').value;
			this.restitutionPrestation.heuresPrev = this.form.get('heuresPrev').value;
			this.restitutionPrestation.totalHeures = this.form.get('totalHeures').value;
			this.restitutionPrestation.heuresBilaterales = this.form.get('heuresBilaterales').value;
			this.restitutionPrestation.heuresCollectif = this.form.get('heuresCollectif').value;
			this.restitutionPrestation.heuresEmployeur = this.form.get('heuresEmployeur').value;
			this.restitutionPrestation.totalHeuresRestantes = this.form.get('totalHeuresRestantes').value;
			this.restitutionPrestation.mobilisationAutreAs = this.form.get('mobilisationAutreAs').value;
			this.restitutionPrestation.raisonSocialeAutre = this.form.get('raisonSocialeAutre')?.value;
			this.restitutionPrestation.pointVigilance = this.form.get('pointVigilance')?.value;
			this.restitutionPrestation.organismePecBenef = this.form.get('organismePecBenef').value;
			this.restitutionPrestation.consequencesHandicap = this.form.get('consequencesHandicap').value;
			this.restitutionPrestation.reponsesIdentifiees = this.listSelectedAide;
			this.restitutionPrestation.aidesTechniques = this.form.get('aidesTechniques')?.value;
			this.restitutionPrestation.aidesHumaines = this.form.get('aidesHumaines')?.value;
			this.restitutionPrestation.aidesOrganisationnelles = this.form.get('aidesOrganisationnelles').value;
			this.restitutionPrestation.mediation = this.form.get('mediation')?.value;
			this.restitutionPrestation.statutDemandeProlongation = this.form.get('statutDemandeProlongation')?.value;
			this.restitutionPrestation.demarcheAdministrative = this.form.get('demarcheAdministrative')?.value;
			this.restitutionPrestation.demarcheAdministrativeDetails = this.form.get('demarcheAdministrativeDetails')?.value;
			console.log(this.restitutionPrestation.demarcheAdministrativeDetails);

			console.log(this.restitutionPrestation);
			this.sendForm.emit();
		} else {
			// this.facade.toastService.createErrorToast();
			this.isValidateButtonClicked.value = false;
		}
	}

	get dateValidQualif() {
		return this.form.get('dateValidQualif');
	}
	get dateButoirDepot() {
		return this.form.get('dateButoirDepot');
	}
	get dateDepotRestFinale() {
		return this.form.get('dateDepotRestFinale');
	}
	get type() {
		return this.form.get('type');
	}
	get prolongation() {
		return this.form.get('prolongation');
	}
	get dateDemarrage() {
		return this.form.get('dateDemarrage');
	}
	get date1erRv() {
		return this.form.get('date1erRv');
	}
	get dateFinPrev() {
		return this.form.get('dateFinPrev');
	}
	get heuresPrev() {
		return this.form.get('heuresPrev');
	}
	get totalHeures() {
		return this.form.get('totalHeures');
	}
	get heuresBilaterales() {
		return this.form.get('heuresBilaterales');
	}
	get heuresCollectif() {
		return this.form.get('heuresCollectif');
	}
	get heuresEmployeur() {
		return this.form.get('heuresEmployeur');
	}
	get totalHeuresRestantes() {
		return this.form.get('totalHeuresRestantes');
	}
	get mobilisationAutreAs() {
		return this.form.get('mobilisationAutreAs');
	}
	get raisonSocialeAutre() {
		return this.form.get('raisonSocialeAutre');
	}
	get pointVigilance() {
		return this.form.get('pointVigilance');
	}
	get organismePecBenef() {
		return this.form.get('organismePecBenef');
	}
	get consequencesHandicap() {
		return this.form.get('consequencesHandicap');
	}
	get reponsesIdentifiees() {
		return this.form.get('reponsesIdentifiees');
	}
	get aidesTechniques() {
		return this.form.get('aidesTechniques');
	}
	get aidesHumaines() {
		return this.form.get('aidesHumaines');
	}
	get aidesOrganisationnelles() {
		return this.form.get('aidesOrganisationnelles');
	}
	get mediation() {
		return this.form.get('mediation');
	}
	get statutDemandeProlongation() {
		return this.form.get('statutDemandeProlongation');
	}
	get demarcheAdministrative() {
		return this.form.get('demarcheAdministrative');
	}
	get demarcheAdministrativeDetails() {
		return this.form.get('demarcheAdministrativeDetails');
	}

	isAddressValidValidator(): ValidatorFn {
		return (control: AbstractControl): ValidationErrors | null => {
			return !(this.isAddressDefault.value || this.isAddressSelected.value)
				? { invalidAddress: { value: control.value } }
				: null;
		};
	}

	
}
